import { Component, input } from '@angular/core';
import { MatRadioButton } from '@angular/material/radio';

@Component({
  selector: 'radio-button-with-description',
  templateUrl: './radio-button-with-description.html',
  styleUrls: ['./radio-button-with-description.scss'],
  imports: [MatRadioButton],
})
export class RadioButtonWithDescriptionComponent {
  label = input.required<string>();
  buttonValue = input.required<any>();
  description = input.required<string>();
}
